import { useQuery } from "@tanstack/react-query";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "../../../api";
import { MIGRATION } from "../../../constants/testIds";

function Row({ ok, children }) {
  return (
    <div className="flex items-center gap-2 text-sm">
      {ok ? <CheckCircle2 size={16} style={{ color: "#3FA65B" }} /> : <XCircle size={16} style={{ color: "#D64545" }} />}
      <span style={{ color: "var(--scarlet-text)" }}>{children}</span>
    </div>
  );
}

// SCR-P04-60 - a read-only go-live readiness dashboard. The actual go-live/sign-off action lives
// on the Parallel-run tab (already hard-gated server-side on this exact checklist) - this screen
// just explains WHY it's blocked, if it is.
export function ChecklistTab() {
  const { data } = useQuery({ queryKey: ["go-live-checklist"], queryFn: () => api.get("/migration/go-live-checklist").then((r) => r.data) });
  if (!data) return null;

  return (
    <div className="space-y-4">
      <div data-testid={MIGRATION.checklistIntegrations} className="solid-surface rounded-[14px] p-5">
        <Row ok={data.integrations_connected}>WhatsApp integration connected and tested successfully</Row>
      </div>

      <div data-testid={MIGRATION.checklistReconciliation} className="solid-surface rounded-[14px] p-5 space-y-2">
        <Row ok={data.counts_reconciled}>Migrated member counts reconcile against every committed batch</Row>
        {data.reconciliation.map((r) => (
          <p key={r.batch_id} className="text-xs pl-6" style={{ color: "var(--scarlet-text-secondary)" }}>
            Batch {r.batch_id.slice(-6)}: expected {r.expected}, actual {r.actual} {r.matched ? "\u2713" : "\u2717"}
          </p>
        ))}
      </div>

      <div data-testid={MIGRATION.checklistRemandate} className="solid-surface rounded-[14px] p-5">
        <p className="text-sm font-medium mb-1" style={{ color: "var(--scarlet-text)" }}>Re-mandate progress (visibility only - does not block go-live)</p>
        <p className="text-xs" style={{ color: "var(--scarlet-text-secondary)" }}>
          {data.remandate_progress.authorized} authorized &middot; {data.remandate_progress.pending} pending &middot; {data.remandate_progress.sent} sent total
        </p>
      </div>

      <div
        data-testid={MIGRATION.checklistGateStatus} className="rounded-[12px] p-4 text-sm font-medium text-center"
        style={data.gate_passed ? { background: "#3FA65B22", color: "#3FA65B" } : { background: "#D6454522", color: "#D64545" }}
      >
        {data.gate_passed ? "Ready to go live" : "Not ready - complete the items above, then go live from the Parallel-run tab"}
      </div>
    </div>
  );
}
